/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SourceOption } from './SourceOption';
import {
    SourceOptionFromJSON,
    SourceOptionFromJSONTyped,
    SourceOptionToJSON,
} from './SourceOption';

/**
 *
 * @export
 * @interface FindAllSourceOptions200Response
 */
export interface FindAllSourceOptions200Response {
    /**
     *
     * @type {Array<SourceOption>}
     * @memberof FindAllSourceOptions200Response
     */
    data: Array<SourceOption>;
}

/**
 * Check if a given object implements the FindAllSourceOptions200Response interface.
 */
export function instanceOfFindAllSourceOptions200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function FindAllSourceOptions200ResponseFromJSON(json: any): FindAllSourceOptions200Response {
    return FindAllSourceOptions200ResponseFromJSONTyped(json, false);
}

export function FindAllSourceOptions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSourceOptions200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'data': ((json['data'] as Array<any>).map(SourceOptionFromJSON)),
    };
}

export function FindAllSourceOptions200ResponseToJSON(value?: FindAllSourceOptions200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'data': ((value.data as Array<any>).map(SourceOptionToJSON)),
    };
}
